import React from 'react';
import './TemplatesPage.css'; // optional for styling

export default function TemplatesPage() {
  return (
    <div className="templates-page">
      <h2>📝 Templates</h2>
      <p>Manage SMS, email, and message templates here.</p>
    </div>
  );
}